import { Pipe, PipeTransform } from '@angular/core';
import {
  AbsenceUnitEnum,
  AbsenceUnitInfo,
} from '@qaroni-app/absences/types/absence-unit.enum';

@Pipe({
  name: 'absenceUnit',
  standalone: false,
})
export class AbsenceUnitPipe implements PipeTransform {
  transform(value: AbsenceUnitEnum): string {
    if (value && Object.prototype.hasOwnProperty.call(AbsenceUnitInfo, value)) {
      return AbsenceUnitInfo[value].name;
    }

    return value;
  }
}
